import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, CodeBlockData } from '../../../../models';
import { CodeNodeView } from './CodeNodeView';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    codeNode: { insertCodeNode: ({ code }: CodeBlockData) => ReturnType };
  }
}

export const CodeNode = Node.create({
  name: 'codeNode',
  group: 'block',
  atom: true,
  markdownTokenName: 'code',

  addAttributes() {
    return { code: '' };
  },

  parseHTML() {
    return [{ tag: BlockTypes.code }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.code, mergeAttributes(HTMLAttributes)];
  },

  parseMarkdown(token, helpers) {
    return helpers.createNode(this.name, { code: token.text });
  },

  addCommands() {
    return {
      insertCodeNode:
        ({ code }: CodeBlockData) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { code } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(CodeNodeView);
  },
});
